import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Badge, Dropdown } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import Drawer from '@mui/material/Drawer';
import vehicle from '../../../../images/vehicle/default_vehicle.png';
import Schedule from '../../../modal/Vehicle_Management/Manage_Vehicle/Schedule';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import AssignStaff from '../../../modal/Vehicle_Management/Manage_Vehicle/AssignStaff';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
          diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff)); 
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
          diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const VehicleManagement = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,
        
        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // --------------------------- pack -------------------
        pack_man: 0,
        man_product: 0,
        prod_catego: 0,
        product_category_list: 0,
        product_category_add: 0,
        product_category_edit: 0,
        product_category_delete: 0,

        product: 0,
        products_list: 0,
        products_add: 0,
        products_edit: 0,
        products_view: 0,
        products_delete: 0,
        products_item_quantity: 0,

        item_quans: 0,
        item_quantity_list: 0,
        item_quantity_edit: 0,
        item_quantity_view: 0,

        man_pack: 0,
        package_list: 0,
        package_edit: 0,
        package_delete: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list : 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

        // ------------------------------- subscription ------------------
        subs_man: 0,
        man_subs: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        subscription_payment: 0,
        subscription_drop: 0,
        subscription_special_case: 0,

        man_order: 0,
        order_list: 0,
        order_edit: 0,
        order_view: 0,
        order_new_subs: 0,
        order_drop_subs: 0,
        order_convert_subscriber: 0,

        man_drop: 0,
        drop_list: 0,
        drop_export: 0,

        // ----------------------------------- payment ------------------------
        pay_man: 0,
        man_payment: 0,
        payment_export: 0,
        payment_list: 0,
        
        man_refund: 0,
        refund_list: 0,
        refund_export: 0,
        refund_update: 0,

        // -------------------------- production ----------------------
        prod_man: 0,
        man_items: 0,
        item_catego: 0,
        item_category_list: 0,
        item_category_add: 0,
        item_category_edit: 0,
        item_category_delete: 0,

        item_sub_catego: 0,
        item_sub_category_list: 0,
        item_sub_category_add: 0,
        item_sub_category_edit: 0,
        item_sub_category_delete: 0,

        items: 0,
        items_list: 0,
        items_add: 0,
        items_edit: 0,
        items_view: 0,
        items_delete: 0,
        item_needed_material: 0,
        item_receipe_notes: 0,

        comp_man: 0,
        complaint_list: 0,
        complaint_add: 0,
        complaint_status: 0,
        complaint_view: 0,

        maintenance_man: 0,
        man_vehi: 0,
        vehicle_list: 0,
        vehicle_add: 0,
        vehicle_edit: 0,
        vehicle_view: 0,
        vehicle_delete: 0,
        vehicle_maintannce: 0,
        vehicle_export: 0,

        man_mainten: 0,
        maintenance_list: 0,
        maintenance_edit: 0,
        maintenance_status: 0
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);


    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.toastMessage) {
            const type = location.state.toastType === 'success' ? toast.success : toast.error;
            type(location.state.toastMessage);
            // ✅ Clear location state so it doesn't show again on refresh
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/manage_vehicle`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };
    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    
    const tableRef = useRef(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    
    const [selectedRow, setSelectedRow] = useState({});
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const handleSchedule = (selectedRow) => {
        setSelectedRow(selectedRow);
        setModalType("Schedule");
        setOpen(true);
    };

    const handleAssign = (selectedRow) => {
        setSelectedRow(selectedRow);
        setModalType("Assign");
        setOpen(true);
    };

    const DeleteModal = (data) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Vehicle
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${data.category_name} - ${data.vehicle_brand}</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
               axios.delete(`${baseURL}/manage_vehicle/${data.sno}`)
               .then((response) => {
                    softRefresh();
                    toast.success("Vehicle Deleted Successfully!");
                }).catch(error => {
                    onClose();
                    console.log(error);
                    toast.error("Vehicle Deletion Failed");
                });
            }
        });
    };

    // ------------------------------------------- Filter Details -------------------------------
    
    // category
    const [categoryoption, setCategoryOption] = useState([]);
    const [catego, setcatego] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/vehiclecategory`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.vehiclecategory_name,
                }));
                const allOption = { value: null, label: "All" };
                setCategoryOption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [filter_brand, setfilterBrand] = useState('');
    const [filter_number, setfilterNumber] = useState(null);
    const [filter_purpose, setfilterpurpose] = useState(null);
    const [filter_type, setfiltertype] = useState(null);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const fuel_type = [
        { value: null, label: "All" },
        { value: 1, label: "Petrol" },
        { value: 2, label: "Diesel" },
        { value: 3, label: "Electric" },
    ];

    const veh_purpose = [
        { value: null, label: "All" },
        { value: 1, label: "Delivery" },
        { value: 2, label: "Office Work" },
        { value: 3, label: "Others" },
    ];

    const onClose = () => {
        setFilterOpen(false);
    };

    const handleGoClick = () => {
        const filter = {
            vehicle_category: catego || '',
            vehicle_brand: filter_brand || '',
            vehicle_number: filter_number || '',
            vehicle_purpose: filter_purpose || '',
            fuel_type: filter_type || '',
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }        
        fetchData(filter);
        onClose();
    };

    // --------------------------------------------------- End Filter ---------------------------------------

    // -------------------------------------------------- Export -----------------------------------//
        
    const exportCSV = () => {
        const columnNames = [
            'S.No', 'Category', 'Brand', 'Model', 
            'Number', 'Manufactured Date', 'Registration Date', 'Color', 'Fuel Type', 'Fuel Capacity',
            'Upcoming Maintenance Date', 'Insurance Company', 'Policy Number', 'Insurance Start Date', 'Insurance End Date'
        ];

        const formattedData = datas.map((item, index) => ({
            'S.No': index + 1,
            'Category': item.category_name,
            'Brand': item.vehicle_brand,
            'Model': item.vehicle_model || '-',
            'Number': item.vehicle_number || '-',
            'Manufactured Date': formatDate(item.manufactured_date) || '-',
            'Registration Date': formatDate(item.registration_date) || '-',
            'Color': item.vehicle_color || '-',
            'Fuel Type': (fuel_type.find(f => f.value === item.fuel_type)?.label) || '-',
            'Fuel Capacity': item.fuel_capacity || '-',
            'Upcoming Maintenance Date': formatDate(item.upcoming_maintenance_date) || '-',
            'Insurance Company': item.insurance_company || '-',
            'Policy Number': item.insurance_policy_number || '-',
            'Insurance Start Date': item.insurance_start_date ? formatDate(item.insurance_start_date) : '-',
            'Insurance End Date': item.insurance_end_date ? formatDate(item.insurance_end_date) : '-',
        }));
        const csv = Papa.unparse({
            fields: columnNames,
            data: formattedData
        });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'vehicle.csv';
        link.click();
    };

    const exportExcel = () => {
        
    
        // Format the data to include the desired columns
        const formattedData = datas.map((item, index) => ({
            'S.No': index + 1,
            'Category': item.category_name,
            'Brand': item.vehicle_brand,
            'Model': item.vehicle_model || '-',
            'Number': item.vehicle_number || '-',
            'Manufactured Date': formatDate(item.manufactured_date) || '-',
            'Registration Date': formatDate(item.registration_date) || '-',
            'Color': item.vehicle_color || '-',
            'Fuel Type': (fuel_type.find(f => f.value === item.fuel_type)?.label) || '-',
            'Fuel Capacity': item.fuel_capacity || '-',
            'Upcoming Maintenance Date': formatDate(item.upcoming_maintenance_date) || '-',
            'Insurance Company': item.insurance_company || '-',
            'Policy Number': item.insurance_policy_number || '-',
            'Insurance Start Date': item.insurance_start_date ? formatDate(item.insurance_start_date) : '-',
            'Insurance End Date': item.insurance_end_date ? formatDate(item.insurance_end_date) : '-',
        }));
    
        // Create worksheet from formatted data
        const ws = XLSX.utils.json_to_sheet(formattedData);
    
        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        // Write the workbook to an Excel file and trigger the download
        XLSX.writeFile(wb, 'vehicle.xlsx');
    };

    const print = () => {
            // Define the column names for printing
        const columnNames = [
            'S.No', 'Category', 'Brand', 'Model', 
            'Number', 'Manufactured Date', 'Registration Date', 'Color', 'Fuel Type', 'Fuel Capacity',
            'Upcoming Maintenance Date', 'Insurance Company', 'Policy Number', 'Insurance Start Date', 'Insurance End Date'
        ];

        // Format the data to include the desired columns
        const formattedData = datas.map((item, index) => ({
            'S.No': index + 1,
            'Category': item.category_name,
            'Brand': item.vehicle_brand,
            'Model': item.vehicle_model || '-',
            'Number': item.vehicle_number || '-',
            'Manufactured Date': formatDate(item.manufactured_date) || '-',
            'Registration Date': formatDate(item.registration_date) || '-',
            'Color': item.vehicle_color || '-',
            'Fuel Type': (fuel_type.find(f => f.value === item.fuel_type)?.label) || '-',
            'Fuel Capacity': item.fuel_capacity || '-',
            'Upcoming Maintenance Date': formatDate(item.upcoming_maintenance_date) || '-',
            'Insurance Company': item.insurance_company || '-',
            'Policy Number': item.insurance_policy_number || '-',
            'Insurance Start Date': item.insurance_start_date ? formatDate(item.insurance_start_date) : '-',
            'Insurance End Date': item.insurance_end_date ? formatDate(item.insurance_end_date) : '-',
        }));

        // Create an HTML table for printing
        let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
            <thead>
                <tr style="background-color: #f2f2f2;">`;

        // Add column headers
        columnNames.forEach(col => {
            printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
        });

        printContent += `</tr></thead><tbody>`;

        // Add the rows of data
        formattedData.forEach(row => {
            printContent += `<tr>`;
            columnNames.forEach(col => {
                printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
            });
            printContent += `</tr>`;
        });

        printContent += `</tbody></table>`;

        // Open the print dialog
        const printWindow = window.open('', '', 'height=800,width=1000');
        printWindow.document.write('<html><head><title>Vehicle Details</title>');
        printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContent);
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for IE >= 10
        printWindow.print();
    };

    // ----------------------------------------- End Export -------------------------------

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    // status change
    const handleStatusToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/manage_vehicle/status/${id}`, {status: newStatus})
            .then(response => {
                // softRefresh();
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Updation Failed");
            });
    };

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Vehicles</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Maintenance Management</li>
                    </ol>
                </div>

                <div className='d-flex align-items-center gap-3 mb-2'>

                    {permissions.vehicle_list === 1 && (
                        <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                            <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                            <span className=''>Filter</span>
                        </Link>
                    )}

                    {permissions.vehicle_export === 1 && (
                        <Dropdown>
                            <Dropdown.Toggle
                                as="button"
                                variant="primary"
                                className="btn btn-primary text-white btn-sm"
                                id="tp-btn"
                            >
                                <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                                <span className=''>Export</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={exportCSV} className='px-2'>
                                    <img
                                        src={csv_ico}
                                        alt="CSV"
                                        className='w-30px h-30px'
                                    />
                                    <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                                </Dropdown.Item>
                                <Dropdown.Item onClick={exportExcel} className='px-2'>
                                    <img
                                        src={excel_ico}
                                        alt="Excel"
                                        className='w-30px h-30px'
                                    />
                                    <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                                </Dropdown.Item>
                                <Dropdown.Item onClick={print} className='px-2'>
                                    <img
                                        src={print_ico}
                                        alt="Print"
                                        className='w-30px h-30px'
                                    />
                                    <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}

                    {permissions.vehicle_add === 1 && (
                        <Link to={"/add-vehicle"} className="btn btn-primary float-end btn-sm" >
                            <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                            <span className=''>Add Vehicle</span>
                        </Link>
                    )}

                    {open && modalType === "Schedule" && (
                        <Schedule show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
                    )}
                    {open && modalType === "Assign" && (
                        <AssignStaff show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
                    )}
                </div>
            </div>

            {permissions.vehicle_list === 1 && (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-100px'>Vehicle</th>
                                <th className='min-w-100px'>Vehile Number / Reg Date</th>
                                <th className='min-w-100px'>Fuel Type / Capacity</th>
                                <th className='min-w-100px'>Maintenance Date</th>
                                <th className='min-w-50px'>Status</th>
                                <th className='min-w-80px'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <tr key={data.sno}>
                                            <td>
                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                    <LightGallery
                                                        onInit={onInit}
                                                        speed={500}
                                                        plugins={[lgThumbnail, lgZoom]}
                                                    >
                                                        <div data-src={(imgBaseUrl && data.vehicle_image) ? imgBaseUrl + '/' + data.vehicle_image : vehicle} className='border rounded px-1 py-0'>
                                                            <img src={(imgBaseUrl && data.vehicle_image) ? imgBaseUrl + '/' + data.vehicle_image : vehicle} alt={data.vehicle_brand + ' ' + data.vehicle_model} className='cursor-pointer w-45px h-45px' />
                                                        </div>
                                                    </LightGallery>
                                                    <div>
                                                        <OverlayTrigger
                                                            trigger={['hover', 'focus']}
                                                            placement="bottom"
                                                            overlay={
                                                                <Tooltip className="tooltip-popover">
                                                                    <span className="fs-8 text-white">Vehicle Category</span>
                                                                </Tooltip>
                                                            }
                                                        ><label className='text-black font-w400 fs-7'>{data.category_name}</label></OverlayTrigger>
                                                        
                                                        <div className="d-block">
                                                            <OverlayTrigger
                                                                trigger={['hover', 'focus']}
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="tooltip-popover">
                                                                        <span className="fs-8 text-white">Brand</span>
                                                                    </Tooltip>
                                                                }
                                                            ><label className="fs-8 text-dark font-w600">{data.vehicle_brand}</label></OverlayTrigger>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.vehicle_number}</label>
                                                <div className="d-block">
                                                    <label className="fs-8 text-dark font-w600">{formatDate(data.registration_date)}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>
                                                    {data.fuel_type === 1 && 'Petrol'}
                                                    {data.fuel_type === 2 && 'Diesel'}
                                                    {data.fuel_type === 3 && 'Electric'}
                                                    </label>
                                                <div className="d-block">
                                                    <label className="fs-8 text-dark font-w600">{data.fuel_capacity !== '' && data.fuel_capacity !== 'null' ? data.fuel_capacity : '-'}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <Badge bg="info" className='text-white fs-7 py-0 px-1'>{formatDate(data.upcoming_maintenance_date)}</Badge>
                                            </td>
                                            <td>
                                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                                    <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked={data.status === 0} onChange={() => handleStatusToggle(data.sno, data.status)} disabled={permissions.vehicle_edit !== 1} />
                                                </div>
                                            </td>
                                            <td>
                                                <span className="text-end">
                                                    {/* {permissions.vehicle_maintannce === 1 && (
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Maintenance Schedule</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleSchedule(data)}>
                                                                <span><i className="fa-solid fa-calendar-days fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    )} */}

                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Assign Staff</span></Tooltip>} >
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleAssign(data)}>
                                                            <span><i class="fa-solid fa-truck-ramp-box fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </OverlayTrigger>

                                                    {permissions.vehicle_view === 1 && (
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                            <Link to="/view-vehicle" state={{ ID: data.sno }}>
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                                    <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                                </Button>
                                                            </Link>
                                                        </OverlayTrigger>
                                                    )}

                                                    {permissions.vehicle_edit === 1 && (
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                            <Link to='/edit-vehicle' state={{ ID: data.sno }}>
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" >
                                                                    <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                                </Button>
                                                            </Link>
                                                        </OverlayTrigger>
                                                    )}

                                                    {permissions.vehicle_delete === 1 && (
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(data)}>
                                                                <span><i className="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    )}

                                                </span>

                                                {permissions.vehicle_maintannce != 1 && permissions.vehicle_view != 1 && permissions.vehicle_edit != 1 && permissions.vehicle_delete != 1  && (
                                                    <div className="text-center">
                                                        No Actions
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {datas.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                                </span>
                            ):(
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            )}

            {permissions.vehicle_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Vehicle Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                    <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Vehicle Category</label>
                                <Select placeholder="Select Vehicle Category"
                                    value={categoryoption.find(option => option.value === catego) || null}
                                    onChange={(selectedOption) => setcatego(selectedOption.value)}
                                    options={categoryoption}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Vehicle Brand</label>
                                <input type="text" className="form-control" placeholder="Enter Vehicle Brand" 
                                    value={filter_brand}
                                    onChange={(e) => {
                                        setfilterBrand(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Vehicle Number</label>
                                <input type="text" className="form-control" placeholder="Enter Vehicle Number" 
                                    value={filter_number}
                                    onChange={(e) => {
                                        setfilterNumber(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Vehicle Purpose</label>
                                <Select placeholder="Select Vehicle Purpose"
                                    value={veh_purpose.find(option => option.value === filter_purpose) || null}
                                    onChange={(selectedOption) => setfilterpurpose(selectedOption.value)}
                                    options={veh_purpose}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Fuel Type</label>
                                <Select placeholder="Select Fuel Type"
                                    value={fuel_type.find(option => option.value === filter_type) || null}
                                    onChange={(selectedOption) => setfiltertype(selectedOption.value)}
                                    options={fuel_type}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary"onClick={() =>{
                            setfiltertype(null);
                            setfilterpurpose(null);
                            setfilterNumber('');
                            setfilterBrand('');
                            setcatego(null);
                            setDateFilSeltValue('all');
                            softRefresh();
                            onClose();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default VehicleManagement;